export default __webpack_public_path__ + "static/media/group-189@3x.160af9d0.png";